import { buttonVariants } from '@playcastdotio/Shadcn';
import pcLogo from '../../../assets/playcast_logo-96x96.png';
import { useCallback, useMemo } from 'react';
import { determineProfileSlug } from '@playcastdotio/SharedComponents';
import { useAuth, useUser } from '@clerk/clerk-react';
import { IdentityPlatform } from '@playcastdotio/CoreTypes';
import constants from '@playcastdotio/GlobalConfig';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

export const Remote = () => {
  const { user } = useUser();
  const { isSignedIn, isLoaded } = useAuth();

  const getProfileUrl = useCallback(() => {
    if (!isLoaded || !isSignedIn || !user) {
      return 'https://pavilion.playcast.io';
    }

    // Get the appropriate profile slug
    const profileSlug = determineProfileSlug({
      authId: user.id,
      username: user.username ?? '',
      platform: IdentityPlatform.CLERK,
    });

    const baseUrl = constants.PAVILION_PLAYER_BASE_URL;
    // Ensure baseUrl ends with a trailing slash
    const baseUrlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

    return profileSlug ? `${baseUrlWithTrailingSlash}${profileSlug}` : baseUrlWithTrailingSlash;
  }, [isLoaded, isSignedIn, user]);

  const profileUrl = useMemo(() => getProfileUrl(), [getProfileUrl]);

  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-2 md:gap-4'>
      <img src={pcLogo} alt='Playcast Logo' className='size-24' />
      <div className='w-full max-w-2xl text-center'>
        <span className='text-2xl'>
          That machine is hosting a session right now, but if you are looking to play a game, you can do that right here in your profile
        </span>
      </div>
      <Link to={profileUrl} className={clsx(buttonVariants(), '!bg-amber-400 hover:!bg-amber-400/80 active:!bg-amber-400/60')}>
        Your Profile
      </Link>
    </div>
  );
};
